/**
 * Centralized session expiry handler.
 * Called by all service interceptors on 401 responses.
 * Sets a flag so HomePage can show a popup before the user continues.
 */

let isHandling = false; // Prevent multiple redirects from concurrent 401s

export const handleSessionExpired = () => {
  if (isHandling) return;
  isHandling = true;

  // Clear all auth data
  localStorage.removeItem('authToken');
  localStorage.removeItem('webApiToken');
  localStorage.removeItem('userData');
  localStorage.removeItem('customerData');
  localStorage.removeItem('salesData');
  localStorage.removeItem('userType');
  localStorage.removeItem('empUID');
  localStorage.removeItem('jobPositionUID');
  localStorage.removeItem('orgUID');
  localStorage.removeItem('orgTypeUID');
  localStorage.removeItem('roleTypeUID');
  localStorage.removeItem('webApiUserData');

  // Set flag so HomePage shows the session expired popup
  sessionStorage.setItem('sessionExpired', 'true');

  // Redirect to home/scan page
  window.location.href = '/';
};
